import { useEffect, useState } from 'react'
import { ensureClientProfile } from '@/lib/client-id'
import { useAuthStore } from '@/store/auth'

export function useClientId() {
  const user = useAuthStore((s) => s.user)
  const [clientId, setClientIdState] = useState<string | null>(null)
  const [resolving, setResolving] = useState(true)

  useEffect(() => {
    let cancelled = false

    async function bootstrap() {
      setResolving(true)
      const resolved = await ensureClientProfile(user)
      if (cancelled) return
      setClientIdState(resolved)
      setResolving(false)
    }

    void bootstrap()

    return () => {
      cancelled = true
    }
  }, [user?.email, user?.name])

  return { clientId, resolving }
}
